import React from "react";
import { Link } from "react-router-dom";
import "./ArcadeFooter.css";

// Site-wide footer. Used on every page so:
//  - The "Made with brains 🧠" tagline stays visible everywhere.
//  - Privacy / Terms / About / Contact links are ALWAYS one click away —
//    required for Google AdSense approval (a common "Low value content"
//    rejection reason is missing/hidden legal links) and useful for
//    TikTok / Meta app reviewers too.
export default function ArcadeFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="arcade-footer-global" data-testid="arcade-footer">
      <nav className="arcade-footer-links" aria-label="Site links">
        <Link to="/about" data-testid="footer-link-about">About</Link>
        <span aria-hidden="true">·</span>
        <Link to="/contact" data-testid="footer-link-contact">Contact</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" data-testid="footer-link-privacy">Privacy Policy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/terms" data-testid="footer-link-terms">Terms of Service</Link>
      </nav>
      <p className="arcade-footer-tagline">
        Made with brains <span aria-hidden="true">🧠</span> — Zombie Arcade · zombiecollector3d.com
      </p>
      <p className="arcade-footer-copy">
        © {year} Zombie Arcade. All rights reserved.
      </p>
    </footer>
  );
}
